export default "__VITE_ASSET__DNUnT8qw__"